export default "__VITE_ASSET__cfccd3bd__"